// Landing "book a demo / contact sales" modal (shared _modal_showcase partial)

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// fields that must be filled/valid before the request can be sent
const REQUIRED_IDS = [
  'modal_demo_name',
  'modal_demo_job_title',
  'modal_demo_email',
  'modal_demo_phone',
  'modal_demo_company',
  'modal_demo_company_size',
  'modal_demo_country',
  'modal_demo_message'
]

const captchaPassed = () => {
  try {
    return typeof grecaptcha !== 'undefined' && grecaptcha.getResponse().length > 0
  } catch (e) {
    return false
  }
}

const fieldValid = (el) => {
  if (!el) return false
  if (el.type === 'checkbox') return el.checked
  const val = (el.value || '').trim()
  if (val === '') return false
  if (el.type === 'email') return EMAIL_RE.test(val)
  return true
}

const markField = (el) => {
  const field = el.closest('.modal-field')
  if (!field) return
  field.classList.toggle('is-valid', fieldValid(el))
  field.classList.toggle('is-invalid', !fieldValid(el))
}

const refreshSubmit = () => {
  const btn = document.querySelector('.button-modal')
  if (!btn) return

  const allRequired  = REQUIRED_IDS.every((id) => fieldValid(document.querySelector('#' + id)))
  const ready        = allRequired && captchaPassed()

  if (ready) {
    btn.classList.remove('background-grey')
    btn.classList.add('background-green')
    btn.removeAttribute('disabled')
    btn.style.cursor = 'pointer'
  } else {
    btn.classList.remove('background-green')
    btn.classList.add('background-grey')
    btn.setAttribute('disabled', 'disabled')
    btn.style.cursor = 'not-allowed'
  }
}

// Switch the modal between "request a demo" and "free trial" variants in place,
// so both CTAs open the same overlay without navigating to /pricing.
const setModalMode = (isTrial) => {
  const modal = document.querySelector('#showcase')
  if (!modal) return
  const title = modal.querySelector('#modal-title')
  const plan  = modal.querySelector('#modal_demo_plan_selected')
  if (title && modal.dataset.titleDemo) {
    title.textContent = isTrial ? modal.dataset.titleTrial : modal.dataset.titleDemo
  }
  if (plan) plan.value = isTrial ? (modal.dataset.trialPlan || '') : ''
}

const displayContactModale = (event) => {
  if (event) event.preventDefault()
  const trigger = event && event.currentTarget
  const isTrial = !!(trigger && (trigger.dataset.trial === 'true' || trigger.classList.contains('book-trial')))
  setModalMode(isTrial)
  const overlay = document.querySelector('.overlay')
  const modal   = document.querySelector('.modal')
  if (overlay) overlay.style.display = 'block'
  if (modal) {
    modal.style.display = 'grid'
    modal.setAttribute('aria-hidden', 'false')
  }
  const first = document.querySelector('#modal_demo_name')
  if (first) first.focus()
}

const hideContactModale = () => {
  const overlay = document.querySelector('.overlay')
  const modal   = document.querySelector('.modal')
  if (overlay) overlay.style.display = 'none'
  if (modal) {
    modal.style.display = 'none'
    modal.setAttribute('aria-hidden', 'true')
  }
}

const acceptCaptcha = () => refreshSubmit()
window.acceptCaptcha = acceptCaptcha

const initDemoForm = () => {
  const box = document.querySelector('.modal .inputs-box')
  if (!box) return

  const btn = document.querySelector('.button-modal')
  if (btn) {
    btn.classList.add('background-grey')
    btn.setAttribute('disabled', 'disabled')
  }

  REQUIRED_IDS.forEach((id) => {
    const el = document.querySelector('#' + id)
    if (!el) return
    const onChange = () => { markField(el); refreshSubmit() }
    ;['input', 'change', 'awesomplete-selectcomplete'].forEach((ev) => el.addEventListener(ev, onChange))
    el.addEventListener('blur', () => markField(el))
  })

  refreshSubmit()
}

const contactModaleInit = () => {
  // open triggers (e.g. pricing "en savoir plus")
  document.querySelectorAll('.book-showcase').forEach((link) => {
    link.addEventListener('click', displayContactModale)
  })

  // close interactions
  const closeBtn = document.querySelector('#close-modal')
  if (closeBtn) closeBtn.addEventListener('click', (e) => { e.preventDefault(); hideContactModale() })

  const overlay = document.querySelector('.overlay')
  if (overlay) overlay.addEventListener('click', hideContactModale)

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideContactModale() })

  initDemoForm()
}

export { contactModaleInit }
